import colors from '../configuration/colors'
import { SKILL_CHECK_MAX_RATING } from '../constants'

import AnalyzeBlueSvg from '../static/images/SkillGroups/analyze.svg'
import AnalyzeWhiteSvg from '../static/images/SkillGroups/analyze_white.svg'
import CommunicateSvg from '../static/images/SkillGroups/communicate.svg'
import CommunicateWhiteSvg from '../static/images/SkillGroups/communicate_white.svg'
import ExploreSvg from '../static/images/SkillGroups/explore.svg'
import ExploreWhiteSvg from '../static/images/SkillGroups/explore_white.svg'
import ReasonSvg from '../static/images/SkillGroups/reason.svg'
import ReasonWhiteSvg from '../static/images/SkillGroups/reason_white.svg'

export const getNormalizedSkillCheck = skillCheck => ({
  ...skillCheck,
  rating: SKILL_CHECK_MAX_RATING *
    parseFloat(skillCheck.rating) /
    parseInt(skillCheck.max_rating ?? SKILL_CHECK_MAX_RATING),
  max_rating: SKILL_CHECK_MAX_RATING
})

export const masteryLevels = [
  {
    name: 'Not Familiar',
    color: '#DAECFF',
    contrastColor: '#347BC2',
    value: 1,
    label: 'Not Familiar'
  },
  {
    name: 'Familiar',
    color: '#91CCFF',
    contrastColor: colors.white,
    value: 2,
    label: 'Familiar'
  },
  {
    name: 'Proficient',
    color: '#4F9EE9',
    contrastColor: colors.white,
    value: 3,
    label: 'Proficient'
  },
  {
    name: 'Mastering',
    color: '#347BC2',
    contrastColor: colors.white,
    value: 4,
    label: 'Mastering'
  }
]

const unstarted = isMentor => ({
  name: isMentor ? 'Not Started' : 'No Feedback',
  color: 'transparent',
  contrastColor: colors.dove,
  border: '#E1E1E1 1px solid',
  light: true // font weight
})

// individual ratings are simple: [0, 1], (1, 2], (2, 3], (3, 4]
// cutoffs for aggregate mastery levels are not at equal intervals
// [0, 1.5), [1.5, 2.4), [2.4, 3.3), [3.3, 4]
// not famil  familiar   proficient  mastering
export const levelCutoffs = [1.5, 2.4, 3.3, Infinity]
export const getMasteryLevelNumber = (rating, isAggregate) => isAggregate
  ? levelCutoffs.findIndex(upperBound => rating < upperBound)
  : Math.max(0, Math.min(Math.ceil(rating) - 1, SKILL_CHECK_MAX_RATING - 1))

export const getMasteryDisplay = (rating, isMentor, isAggregate) => 
  rating === null || rating < 0
    ? unstarted(isMentor)
    : masteryLevels[getMasteryLevelNumber(rating, isAggregate)]

export const getMasteryColor = (rating, isAggregate) =>
  getMasteryDisplay(rating, false, isAggregate).color
export const getMasteryLevel = (rating, isMentor, isAggregate) =>
  getMasteryDisplay(rating, isMentor, isAggregate).name

const gradients = [
  ['#BEE1FF','#8CC4F5'],
  ['#BEE1FF','#8CC4F5'],
  ['#8CC4F5','#5AA3E5'],
  ['#5AA3E5','#338DE3'],
  ['#4F9EE9','#347BC2']
]

export const getSkillCheckGradient = rating => {
  const ends = gradients[Math.ceil(rating)]
  return {
    gradient: `linear-gradient(90deg, ${ends[0]} 0%, ${ends[1]} 100%)`,
    pointer: ends[1]
  }
}

export const getSkillGroupIconSvg = (skillGroup, isWhite) => {
  switch (skillGroup?.id) {
    case 2:
      return isWhite ? CommunicateWhiteSvg : CommunicateSvg
    case 3:
      return isWhite ? ReasonWhiteSvg : ReasonSvg
    case 4:
      return isWhite ? AnalyzeWhiteSvg : AnalyzeBlueSvg
    case 5:
      return isWhite ? ExploreWhiteSvg : ExploreSvg
    default:
      return null
  }
}

export const getFrameworkSkillWithGroup = (
  frameworkSkillId,
  frameworkSkills,
  frameworkSkillGroups
) => {
  const skill = frameworkSkills.find(fs => fs.id === frameworkSkillId)
  const group = frameworkSkillGroups.find(
    fsg => fsg.id === skill.framework_skill_group_id
  )

  return { ...skill, group }
}

export const getFrameworkGroupId = (frameworkSkillId, frameworkSkills) =>
  frameworkSkills.find(
    fs => fs.id === frameworkSkillId
  ).framework_skill_group_id

export const getLearningSkillGroupBEName = frameworkSkillGroupId => {
  switch (frameworkSkillGroupId) {
    case 2: return 'communicate'
    case 3: return 'reason'
    case 4: return 'analyze'
    case 5: return 'explore'
    default: return ''
  }
}
